import React, { useEffect, useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import Close from "@material-ui/icons/Close";
import Datetime from "react-datetime";
import { ClipLoader } from "react-spinners";

import { connect } from "react-redux";
import Button from "components/CustomButtons/Button.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInputValidate";
import { no_letters } from "shared/validation";
import * as actions from "store/actions";
import { clone } from "shared/utility";
import { isValidDate } from "../../shared/utility";
import CustomDateInput from "../../components/DateInput/CustomDateInput";
import moment from "moment";
import { get } from "lodash";
import { commissionCalc } from "../RSheets/CommonCustomElements/CommissionLogic";

const InvoiceApplyPaymentDialog = (props) => {
    console.log('InvoiceApplyPaymentDialog', props);
    const { open, close, createInvoicePayment, invoice, success_payments, error_payments } = props;

    const [payment, setPayment] = useState({
        date: "",
        amount: "",
        checkNumber: "",
        payee: "",
        deposit_date: "",
        payment_received_date: ""
    });
    const [submitting, setSubmitting] = useState(false);
    const [waitingForPaymentStart, setWaitingForPaymentStart] = useState(false);
    const [submitError, setSubmitError] = useState(null);

    useEffect(() => {
        if (!submitting) {
            return;
        }

        if (waitingForPaymentStart) {
            if (!success_payments && !error_payments) {
                setWaitingForPaymentStart(false);
            }
            return;
        }

        if (success_payments) {
            setSubmitting(false);
            close();
            return;
        }

        if (error_payments) {
            const message = typeof error_payments === "string"
                ? error_payments
                : (error_payments.message || error_payments.error || "Could not apply payment.");
            setSubmitError(message);
            setSubmitting(false);
        }
    }, [close, error_payments, submitting, success_payments, waitingForPaymentStart]);

    const formatDate = (date) => {
        const arr = date.split('/');
        return `${arr[2]}-${arr[0]}-${arr[1]}`;
    }

    const handleChange = (name, value) => {
        const newPayment = clone(payment);
        newPayment[name] = value;
        setPayment(newPayment);
    };

    const { date, amount, checkNumber, payee, deposit_date, payment_received_date } = payment;

    const canSubmit = date && moment(date).isValid();

    const rsData = get(props, 'invoice.json_data', null);
    const rsType = get(props, 'invoice.data.type', null);

    console.log('InvoiceApplyPaymentDialog', props, rsData);

    return (
        <Dialog open={open} onClose={close} keepMounted maxWidth={false} fullWidth={false}>
            <div
                className="close-btn"
                onClick={() => {
                    close();
                }}
            >
                <Close />
            </div>
            <div style={{ margin: 20, padding: 50 }}>
                <h3>APPLY PAYMENT</h3>
                <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                        <CustomDateInput
                            label="Payment Date"
                            onChange={(e) => {
                                let stringDate = e;
                                if (typeof e === "object") {
                                    stringDate = e.format("MM/DD/YYYY");
                                }
                                handleChange("date", stringDate);
                            }}
                            value={date}
                            isRequired
                        />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12}>
                        <CustomInput
                            label={"Payment Amount"}
                            value={amount}
                            onChange={(e) => {
                                handleChange("amount", e.target.value);
                            }}
                            isDollar
                        />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12}>
                        <CustomInput
                            label={"Check Number"}
                            value={checkNumber}
                            onChange={(e) => {
                                handleChange("checkNumber", e.target.value);
                            }}
                        />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12}>
                        <CustomInput
                            label={"Payee Name"}
                            value={payee}
                            onChange={(e) => {
                                handleChange("payee", e.target.value);
                            }}
                        />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12}>
                        <CustomDateInput
                            label="Deposit Date"
                            onChange={(e) => {
                                let stringDate = e;
                                if (typeof e === "object") {
                                    stringDate = e.format("MM/DD/YYYY");
                                }
                                handleChange("deposit_date", stringDate);
                            }}
                            value={deposit_date}
                        />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12}>
                        <CustomDateInput
                            label="Payment Received Date"
                            onChange={(e) => {
                                let stringDate = e;
                                if (typeof e === "object") {
                                    stringDate = e.format("MM/DD/YYYY");
                                }
                                handleChange("payment_received_date", stringDate);
                            }}
                            value={payment_received_date}
                        />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12}>
                        <Button
                            color="danger"
                            disabled={!canSubmit || submitting}
                            style={{ marginTop: 30, marginRight: 20 }}
                            onClick={() => {
                                setSubmitError(null);
                                setSubmitting(true);
                                setWaitingForPaymentStart(true);
                                const rsDataForCalculation = clone(rsData);
                                const all_commission_calculations = commissionCalc.calculate(rsDataForCalculation, rsType);
                                createInvoicePayment({
                                    payment_date: formatDate(payment.date),
                                    payment_amount: payment.amount,
                                    check_number: payment.checkNumber,
                                    payee_name: payment.payee,
                                    rs_id: invoice.rs_id,
                                    invoice_id: invoice.id,
                                    payment_received_date: payment.payment_received_date,
                                    deposit_date: payment.deposit_date
                                }, {
                                    all_commission_calculations,
                                    rsData: rsDataForCalculation
                                });
                            }}
                        >
                            {submitting ? "APPLYING..." : "SUBMIT"}
                        </Button>
                        <Button
                            disabled={submitting}
                            style={{ marginTop: 30, marginRight: 20 }}
                            onClick={() => {
                                close();
                            }}
                        >
                            CLOSE
                        </Button>
                        {submitting && (
                            <div style={{ display: "flex", alignItems: "center", marginTop: 20, color: "#555" }}>
                                <ClipLoader size={24} color="#f44336" />
                                <span style={{ marginLeft: 12 }}>Applying payment and generating payment report...</span>
                            </div>
                        )}
                        {submitError && (
                            <div style={{ marginTop: 20, color: "#f44336" }}>
                                {submitError}
                            </div>
                        )}
                    </GridItem>
                </GridContainer>
            </div>
        </Dialog>
    );
};

const mapStateToProps = (state) => {
    return {
        success_payments: state.invoice.success_payments,
        error_payments: state.invoice.error_payments
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        createInvoicePayment: (data, otherData) => dispatch(actions.createInvoicePayment(data, otherData)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(InvoiceApplyPaymentDialog);
